// extracted by mini-css-extract-plugin
export var logo = "_kh-2";
export var logoWrapper = "_kh-1";
export var strip = "_kh-0";